import React, { Fragment, FormEvent } from "react";
import Navbar from "../../components/Navbar/Navbar";
import WeddingCountdown from "../../components/WeddingCountdown/WeddingCountdown";
import Bg from "../../images/coming.jpg";

const ComingSoonPage: React.FC = () => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    console.log("Notify form submitted!");
  };

  return (
    <Fragment>
      <Navbar hclass="header-style-s2" />
      <section
        className="wpo-coming-soon-area"
        style={{
          background: `url(${Bg}) no-repeat center top / cover`,
        }}
      >
        <div className="hero-container">
          <div className="hero-inner">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="wpo-event-wrap">
                    <div className="wpo-event-item">
                      <div className="coming-soon-section">
                        <div className="row justify-content-center">
                          {/* Title Section */}
                          <div className="col-lg-7">
                            <div className="coming-soon-text text-center">
                              <h2>Coming Soon</h2>
                              <p>
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor incididunt
                                ut labore et dolore magna aliqua.
                              </p>
                            </div>
                          </div>

                          {/* Countdown */}
                          <div className="col-lg-12">
                            <div className="wpo-wedding-date">
                              <h2 className="hidden">Countdown</h2>
                              <div className="clock-grids">
                                <WeddingCountdown />
                              </div>
                            </div>
                          </div>

                          {/* Notify Form */}
                          <div className="col-lg-12">
                            <div className="wpo-coming-contact">
                              <form
                                method="post"
                                className="contact-validation-active"
                                id="contact-form-main"
                                onSubmit={handleSubmit}
                              >
                                <div className="row justify-content-center">
                                  <div className="col-lg-5 col-sm-6 col-12">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="name"
                                      id="name"
                                      placeholder="Name*"
                                      required
                                    />
                                  </div>
                                  <div className="col-lg-5 col-sm-6 col-12">
                                    <input
                                      type="email"
                                      className="form-control"
                                      name="email"
                                      id="email"
                                      placeholder="Email"
                                      required
                                    />
                                  </div>
                                  <div className="col-lg-2 col-sm-4 col-6">
                                    <div className="submit-area">
                                      <button type="submit">Notify Me</button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default ComingSoonPage;
